/**
 * Allows to specify a targeted area of the image to retain.
 *
 * @param imageFocalPoint string
 * @returns image position for X and Y axis.
 */
export function getMediaFocalPoint(imageFocalPoint: string) {
  if (!imageFocalPoint) return null;
  const position = imageFocalPoint?.split('-');
  return {
    focalPointX: position[1] as HTMLUiFlashcardElement['imageFocalPointX'],
    focalPointY: position[0] as HTMLUiFlashcardElement['imageFocalPointY'],
  };
}

/**
 * Converts filesize to kilobytes.
 *
 * @param filesize string in bytes
 * @returns formatted filesize in kilobyte with thousend separator
 */
export function convertFilesizeToKilobyte(filesize: number | string) {
  if (!filesize) return null;
  const convert = `${Math.round(Number(filesize) / 1024)} KB`;
  return convert;
  // return convert.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.');
}

/**
 * Checks if the given value is a valid email address.
 */
export const isEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailRegex.test(email);
};

/**
 * Validates the input value based on the given type.
 */
export const inputValidator = (type: string, value: string): boolean => {
  let isValid = true;

  if (type === 'text' || type === 'textarea') {
    isValid = value.trim() !== '';
  }

  if (type === 'email') {
    isValid = isEmail(value);
  }

  if (type === 'checkbox') {
    isValid = value.trim() !== '';
  }

  return isValid;
};

/**
 * Replaces the checkmark icons in the CK Editor with the SD Icon component
 */
export const replaceCheckmarkIcons = (component: ParentNode) => {
  const magnoliaIconLists = component.querySelectorAll('.magnolia-ck-editor-list');
  magnoliaIconLists.forEach((magnoliaIconList) => {
    const listItems = Array.from(magnoliaIconList.querySelectorAll('li'));
    const transformedItems = listItems.map(
      (item) => `<li><sd-icon name="content/checkbox"></sd-icon> ${item.innerHTML}</li>`
    );
    magnoliaIconList.classList.add('sd-list--icon', 'sd-list');
    const markup = transformedItems.join('');
    // eslint-disable-next-line no-param-reassign
    magnoliaIconList.innerHTML = markup;
  });
};
